import { render, staticRenderFns } from "./BlogFour.vue?vue&type=template&id=7b5aa730&"
import script from "./BlogFour.vue?vue&type=script&lang=js&"
export * from "./BlogFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports